import React, { useState } from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import ModalConfirmation from '../../components/fragments/ModalConfirmation';
import FormInventoryReward from './FormInventoryReward';
import { useMutation } from '@tanstack/react-query';
import { saveImage } from '../../services/inventoryReward';
import { showNotification } from '../../utilities/mantineNotification';
import { Loader, LoadingOverlay, Stack, Text } from '@mantine/core';

interface CreateInventoryRewardProps {
  isVisible: boolean;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (data: any) => void;
  data: any;
  type: string;
}

const CreateInventoryReward: React.FC<CreateInventoryRewardProps> = ({
  isVisible,
  onSubmit,
  onClose,
  loading,
  data,
  type
}) => {
  const [modalDialog, setModalDialog] = useState({
    show: false,
    data: null
  });

  const handleSubmitData = (data: any) => {
    setModalDialog({
      show: true,
      data: data
    });
  };

  const uploadImage = useMutation({
    mutationFn: (data: any) =>
      saveImage({
        FileName: data.rewardImage.fileName,
        FileData: data.rewardImage.base64
      }),
    onSuccess: (response) => {
      const imageUrl = response.data.data.filePath;
      showNotification({
        type: 'success',
        title: 'Success Upload Image',
        message: 'Image has been uploaded'
      });
      onSubmit({ ...modalDialog.data, rewardImage: imageUrl });
      handleCloseModal();
    },
    onError: (error: any) => {
      console.error('error', error);
      showNotification({
        type: 'error',
        message: error?.errorMessage
          ? JSON.stringify(error?.errorMessage)
          : 'Failed to upload image. Please change the image into .png/.jpg and try again.'
      });
    }
  });

  const handleCloseModal = () => {
    setModalDialog({
      show: false,
      data: null
    });
  };

  const handleConfirm = () => {
    // console.log(data?.rewardImage);
    if (modalDialog.data.rewardImage !== data?.rewardImage) {
      setModalDialog({
        show: false,
        data: {
          ...modalDialog.data,
          rewardImage: JSON.parse(modalDialog.data.rewardImage)
        }
      });
      const payload = {
        ...modalDialog.data,
        rewardImage: JSON.parse(modalDialog.data.rewardImage)
      };
      uploadImage.mutate(payload);
      return;
    }
    onSubmit(modalDialog.data);
    handleCloseModal();
  };

  return (
    <>
      <ModalWrapper
        title={`${type === 'edit' ? 'Update' : 'Create'} Inventory Reward`}
        isVisible={isVisible}
        onClose={onClose}
        size={'xl'}
      >
        <FormInventoryReward
          onClose={onClose}
          loading={loading || uploadImage.isLoading}
          handleSubmitData={handleSubmitData}
          type={type}
          data={data}
        />
        <LoadingOverlay
          visible={uploadImage.isLoading || loading}
          loaderProps={{
            children: (
              <Stack align="center">
                <Loader size={30} />
                <Text style={{ textAlign: 'center' }}>
                  {uploadImage.isLoading
                    ? 'Uploading Image...'
                    : 'Submitting...'}
                </Text>
              </Stack>
            )
          }}
        />
      </ModalWrapper>

      <ModalConfirmation
        isVisible={modalDialog.show}
        type={type}
        onCancel={handleCloseModal}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default CreateInventoryReward;
